import { IconButton } from '@ori-ui/components';
import { Add } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';

export const Root = styled(IconButton)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.common.black,
  height: 20,
  justifyContent: 'center',
  left: theme.spacing(-2),
  position: 'absolute',
  top: theme.spacing(1),
  width: 20,
  zIndex: 1,
}));

export const Icon = styled(Add)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  transform: 'rotate(45deg)',
}));
